import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Link } from 'react-router-dom';
import * as paths from '@app/constants/paths';
import MediaQuery from 'react-responsive';
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Parallax from "@app/components/Parallax/Parallax";
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import Button from "@app/components/CustomButtons/Button";
// styles
import landingIntroStyle from "@app/assets/jss/material-kit-pro-react/views/landingPageSections/landingIntroStyle";
const LandingIntro = props => {
    const { classes } = props;
    const videoArray = {
        0: "https://www.youtube.com/embed/yy-pRc2L8gc",
        1: "https://www.youtube.com/embed/jaHPvFN23nY",
        2: "https://www.youtube.com/embed/_Xcm9SWyWV4"
    }
    return (
        <div className={classes.container}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                    <div>
                        <MediaQuery minWidth={300}>
                            <h1 className={classes.title}>
                                <FormattedMessage id="what.landing" />
                            </h1>
                        </MediaQuery>
                        <MediaQuery minHeight={500}>
                            <p className={classes.cardDescription}>
                                <FormattedMessage id="how.landing" />
                            </p>
                        </MediaQuery>
                        <Button 
                            color="danger" 
                            size="lg"
                            to={paths.SIGN_UP_PROFESSIONAL} 
                            component={Link}
                            aria-label={props.intl.formatMessage({ id: "start.for.free" })}>
                            <b>
                                <FormattedMessage id="start.for.free" />
                            </b>
                        </Button>
                    </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} className={classes.mlAuto}>
                    <div className={classes.iframeContainer}>
                        <iframe
                            height="250"
                            src={videoArray[Math.floor(Math.random() * Math.floor(3))]}
                            frameBorder="0"
                            allow="encrypted-media"
                            allowFullScreen=""
                            title="Tesla"
                        />
                    </div>
                </GridItem>
            </GridContainer>
        </div>
    );
}


export default injectIntl(withStyles(landingIntroStyle)(LandingIntro));